<template>
  <div class="redesign new-journal">
    <slot />
  </div>
</template>
<script>


export default {
  data: () => {
    return {}
  },
  components: {
  },
  async created() {
    await this.$store.dispatch('getUser');
  }
}
</script>
